/**
 * Собирает транспортный контракт задач без привязки экранов к URL.
 *
 * @param {{get: Function, post: Function, put: Function, delete: Function}} http
 */
export function createTasksApi(http) {
    const taskUrl = taskId => `/tasks/${taskId}`;
    const taskGroupUrl = taskGroupId => `/task_groups/${taskGroupId}`;
    const targetTasksUrl = (modelName, modelId) => `/tasks/${modelName}_${modelId}/tasks`;

    return {
        loadTasks(modelName, modelId, callback) {
            return http.get(targetTasksUrl(modelName, modelId), callback);
        },
        createTask(modelName, modelId, payload, callback) {
            return http.post(targetTasksUrl(modelName, modelId), payload, callback);
        },
        deleteTask(taskId, callback) {
            return http.delete(taskUrl(taskId), {}, callback);
        },
        takeTaskToWork(taskId, callback) {
            return http.post(`/tasks/to-work/${taskId}`, {}, callback);
        },
        pauseTask(taskId, callback) {
            return http.post(`/tasks/pause/${taskId}`, {}, callback);
        },
        closeTask(taskId, callback) {
            return http.post(`/tasks/close/${taskId}`, {}, callback);
        },
        loadTaskGroups(callback) {
            return http.get('/task_groups', callback);
        },
        loadTaskGroup(taskGroupId, callback) {
            return http.get(taskGroupUrl(taskGroupId), callback);
        },
        createTaskGroup(payload, callback, fallback) {
            return http.post('/task_groups', payload, callback, fallback);
        },
        updateTaskGroup(taskGroupId, payload, callback, fallback) {
            return http.put(taskGroupUrl(taskGroupId), payload, callback, fallback);
        },
        deleteAllTaskGroupTasks(taskGroupId, callback) {
            return http.delete(`${taskUrl(taskGroupId)}/delete-all`, {}, callback);
        },
        deleteOpenTaskGroupTasks(taskGroupId, callback) {
            return http.delete(`${taskUrl(taskGroupId)}/delete-not-closed`, {}, callback);
        },
        loadNextTask(missed, callback) {
            return http.post('/tasks/next', {missed}, callback);
        },
        createTasksForOrders(payload, callback) {
            return http.post('/create-tasks-for-orders', payload, callback);
        },
    };
}
